import styled from 'foundations-theming/utils';
export const StyledSpan = styled.div.withConfig({
  displayName: "commonStyles__StyledSpan",
  componentId: "sc-19znp08-0"
})(["font-weight:", ";text-transform:uppercase;"], ({
  theme
}) => theme.typography['heading-100'].fontWeight);
export const AccordionItemWrapper = styled.div.withConfig({
  displayName: "commonStyles__AccordionItemWrapper",
  componentId: "sc-19znp08-1"
})(["padding:15px 20px;.accordion-item{margin:0;}.accordion-header{font-weight:600;text-transform:uppercase;}"]);
export const UserFacingMessageAlertWrapper = styled.div.withConfig({
  displayName: "commonStyles__UserFacingMessageAlertWrapper",
  componentId: "sc-19znp08-2"
})(["font-weight:", ";"], ({
  theme
}) => theme.typography['heading-1000'].fontWeight);
export const StyledTextWithoutIndentWrapper = styled.div.withConfig({
  displayName: "commonStyles__StyledTextWithoutIndentWrapper",
  componentId: "sc-19znp08-3"
})(["> p{margin-bottom:", ";}"], ({
  theme
}) => theme.space['0']);